export default "__VITE_ASSET__DkeyDIOt__"